import {useToast} from 'vue-toastification';
import {NOTIFY_THROTTLE_MS} from '@/constants';

// Простейший централизованный нотифаер с троттлингом по id
const lastShownAt = new Map();

function canShow(id) {
	if (!id) return true;
	const now = Date.now();
	const last = lastShownAt.get(id) || 0;
	if (now - last < NOTIFY_THROTTLE_MS) return false;
	lastShownAt.set(id, now);
	return true;
}

function show(kind, message, {id, timeout} = {}) {
	const toast = useToast();
	if (!canShow(id)) return;
	const opts = {};
	if (id) opts.id = id;
	if (timeout) opts.timeout = timeout;
	if (kind === 'success') return toast.success(message, opts);
	if (kind === 'warning') return toast.warning(message, opts);
	if (kind === 'info') return toast.info(message, opts);
	return toast.error(message, opts);
}

export const notifier = {
	success(id, message, timeout) {
		return show('success', message, {id, timeout});
	},
	warn(id, message, timeout) {
		return show('warning', message, {id, timeout});
	},
	info(id, message, timeout) {
		return show('info', message, {id, timeout});
	},
	error(id, message, timeout) {
		return show('error', message, {id, timeout});
	},
};

export default notifier;


